/* kts-preorder-links.js — GENERADO por _seo_control/aplicar_estado.py desde ESTADO.json.
   NO editar a mano: se regenera y se pierden los cambios.

   Por qué existe: el sitio tiene ~556 enlaces comerciales (botones "Shop X", tarjetas de
   producto) apuntando a productos en PREVENTA sin decirlo. La política del 25-ago-2026 permite
   enlazar a preventa, pero prohíbe presentarla como disponible. Editar 556 bloques en 5 idiomas
   no es viable ni se mantiene: esto lo resuelve en un solo sitio y la fecha sale de ESTADO.json.

   Qué hace: a cada enlace comercial hacia un producto en preventa le añade una nota con la
   etiqueta y la fecha del lote. NO toca el enlace si su bloque ya lo declara. */
(function(){
  var MAPA = {
 "vinyl-modular-x4-modular-vinyl-storage-system-200-lps": {
  "en": "Pre-order · ships late December 2026",
  "es": "Preventa · envío finales de diciembre 2026",
  "de": "Vorbestellung · Versand Ende Dezember 2026",
  "fr": "Précommande · expédition fin décembre 2026",
  "it": "Pre-ordine · spedizione fine dicembre 2026"
 },
 "vinyl-modular-stackable-vinyl-record-storage-50-lps": {
  "en": "Pre-order · ships late December 2026",
  "es": "Preventa · envío finales de diciembre 2026",
  "de": "Vorbestellung · Versand Ende Dezember 2026",
  "fr": "Précommande · expédition fin décembre 2026",
  "it": "Pre-ordine · spedizione fine dicembre 2026"
 },
 "modular-foreigner-combined-vinyl-storage-system-120-lps": {
  "en": "Pre-order · ships late December 2026",
  "es": "Preventa · envío finales de diciembre 2026",
  "de": "Vorbestellung · Versand Ende Dezember 2026",
  "fr": "Précommande · expédition fin décembre 2026",
  "it": "Pre-ordine · spedizione fine dicembre 2026"
 },
 "the-diggers-stack-complete-vinyl-station-150-lp-capacity": {
  "en": "Pre-order · ships late December 2026",
  "es": "Preventa · envío finales de diciembre 2026",
  "de": "Vorbestellung · Versand Ende Dezember 2026",
  "fr": "Précommande · expédition fin décembre 2026",
  "it": "Pre-ordine · spedizione fine dicembre 2026"
 },
 "the-iroko-rack-complete-vinyl-station-170-lp-capacity-limited-edition": {
  "en": "Pre-order · ships late December 2026",
  "es": "Preventa · envío finales de diciembre 2026",
  "de": "Vorbestellung · Versand Ende Dezember 2026",
  "fr": "Précommande · expédition fin décembre 2026",
  "it": "Pre-ordine · spedizione fine dicembre 2026"
 },
 "the-digger-s-wall-complete-vinyl-station-600-lp": {
  "en": "Pre-order · ships late December 2026",
  "es": "Preventa · envío finales de diciembre 2026",
  "de": "Vorbestellung · Versand Ende Dezember 2026",
  "fr": "Précommande · expédition fin décembre 2026",
  "it": "Pre-ordine · spedizione fine dicembre 2026"
 },
 "the-digger-s-library": {
  "en": "Pre-order · ships late December 2026",
  "es": "Preventa · envío finales de diciembre 2026",
  "de": "Vorbestellung · Versand Ende Dezember 2026",
  "fr": "Précommande · expédition fin décembre 2026",
  "it": "Pre-ordine · spedizione fine dicembre 2026"
 },
 "rsd-pre-order-exclusive-record-store-day-bundle": {
  "en": "Pre-order · ships late December 2026",
  "es": "Preventa · envío finales de diciembre 2026",
  "de": "Vorbestellung · Versand Ende Dezember 2026",
  "fr": "Précommande · expédition fin décembre 2026",
  "it": "Pre-ordine · spedizione fine dicembre 2026"
 },
 "vinyl-modular-door": {
  "en": "Pre-order · ships late December 2026",
  "es": "Preventa · envío finales de diciembre 2026",
  "de": "Vorbestellung · Versand Ende Dezember 2026",
  "fr": "Précommande · expédition fin décembre 2026",
  "it": "Pre-ordine · spedizione fine dicembre 2026"
 },
 "vinyl-break-minimalist-steel-record-stand-for-display-storage-50-lps": {
  "en": "Pre-order · ships late December 2026",
  "es": "Preventa · envío finales de diciembre 2026",
  "de": "Vorbestellung · Versand Ende Dezember 2026",
  "fr": "Précommande · expédition fin décembre 2026",
  "it": "Pre-ordine · spedizione fine dicembre 2026"
 },
 "flying-v-x2-double-wall-mounted-vinyl-display-100-120-lps": {
  "en": "Pre-order · ships late December 2026",
  "es": "Preventa · envío finales de diciembre 2026",
  "de": "Vorbestellung · Versand Ende Dezember 2026",
  "fr": "Précommande · expédition fin décembre 2026",
  "it": "Pre-ordine · spedizione fine dicembre 2026"
 },
 "flying-v-x8-gallery-wall-vinyl-display-480-lps": {
  "en": "Pre-order · ships late December 2026",
  "es": "Preventa · envío finales de diciembre 2026",
  "de": "Vorbestellung · Versand Ende Dezember 2026",
  "fr": "Précommande · expédition fin décembre 2026",
  "it": "Pre-ordine · spedizione fine dicembre 2026"
 },
 "__locs": [
  "en",
  "es",
  "de",
  "fr",
  "it"
 ]
};
  var YA = /pre-?order|preventa|pre-?pedido|vorbestell|pr[ée]-?commande|pre-?ordine/i;
  function idioma(){
    var l=(document.documentElement.getAttribute('lang')||'en').slice(0,2).toLowerCase();
    return MAPA.__locs.indexOf(l)>=0 ? l : 'en';
  }
  function esComercial(a){
    /* Un enlace a producto es COMERCIAL si se presenta como botón o como tarjeta.
       No basta con mirar clases: muchas tarjetas llevan el estilo inline y ninguna clase
       (p.ej. /pages/keep-them-spinning-faqs). Se detecta por cómo RENDERIZA:
       bloque ancho, o contiene imagen, o muestra precio. Un enlace de texto dentro de un
       párrafo NO cuenta: ahí la nota sobraría y ensuciaría la lectura. */
    if (/kts[a-z-]*btn|ktslp-btn|kts-card|kts-showcase|kts-related-links|ktslp-blog-cta/i.test(a.className||'')) return true;
    if (a.closest('.kts-card,.kts-showcase,.ktslp-blog-cta,.kts-related-links,.ktslp-ctas')) return true;
    if (a.querySelector('img')) return true;
    if (/[€$]\s?\d/.test(a.textContent||'')) return true;
    var cs=getComputedStyle(a), d=cs.display;
    var ancho=a.getBoundingClientRect().width;
    if ((d==='block'||d==='flex'||d==='grid'||d==='inline-block'||d==='inline-flex') && ancho>=140) return true;
    return /^(shop|buy|comprar|ver|kaufen|acheter|acquista|reserve|reservar)/i.test((a.textContent||'').trim());
  }
  function bloque(a){
    /* Subir hasta un contenedor con TEXTO DE VERDAD. El ancestro más cercano suele ser el
       div que envuelve solo el botón: mirar ahí hace que no veamos la declaración que sí
       está dos niveles más arriba, y acabamos duplicando la nota. (Visto el 25-ago-2026
       en /pages/the-10-rarest…, que ya declaraba la preventa.) */
    var p=a.parentElement, mejor=null;
    for (var i=0;i<6 && p;i++,p=p.parentElement){
      var t=(p.textContent||'').trim();
      if (t.length>=140){ mejor=p; break; }
      mejor=p;
    }
    return mejor||a.parentElement;
  }
  /* ── CONTRASTE ─────────────────────────────────────────────────────────────
     Historia: el 25-ago puse `color:inherit` porque intentar ADIVINAR el fondo
     fallaba en las bandas con imagen. Pero heredar falla en el caso contrario:
     una caja oscura (#2B2B2B) dentro de un `.rte` cuyo color heredado es
     oscuro -> texto #121212 sobre #2B2B2B = contraste 1,1:1, ilegible.
     La solución no es elegir a ciegas ninguna de las dos: es MEDIR el
     resultado. Se parte de `inherit` (acierta en la mayoría) y solo se
     corrige cuando el contraste medido baja de 3:1. Así solo puede mejorar
     casos que hoy están rotos, nunca empeorar los que están bien. */
  function _rgb(s){
    var m=(s||'').match(/rgba?\(([^)]+)\)/); if(!m) return null;
    var p=m[1].split(',').map(parseFloat);
    return {r:p[0],g:p[1],b:p[2],a:p.length>3?p[3]:1};
  }
  function _sobre(fg,bg){ var a=fg.a;
    return {r:fg.r*a+bg.r*(1-a), g:fg.g*a+bg.g*(1-a), b:fg.b*a+bg.b*(1-a), a:1}; }
  function _lum(c){ var f=function(v){v/=255;return v<=0.03928?v/12.92:Math.pow((v+0.055)/1.055,2.4)};
    return 0.2126*f(c.r)+0.7152*f(c.g)+0.0722*f(c.b); }
  function _ratio(a,b){ var x=_lum(a),y=_lum(b),hi=Math.max(x,y),lo=Math.min(x,y);
    return (hi+0.05)/(lo+0.05); }
  /* Un degradado NO aparece en backgroundColor. La seccion .ktslp-final es
     `background-color: transparent` + `linear-gradient(135deg,#1A1A1A,#2B2B2B)`:
     mirar solo backgroundColor devolvia BLANCO, y con eso el rescate dedujo
     "fondo claro" y forzo texto oscuro sobre un degradado negro. Es decir: mi
     propio arreglo rompio el boton. (27-ago-2026, lo vio Guillermo.)
     Ahora se leen los topes de color del degradado y se promedian. */
  function _delGradiente(bgImage){
    if (!bgImage || bgImage==='none') return null;
    var m=bgImage.match(/rgba?\([^)]+\)/g);
    if (!m || !m.length) return null;
    var sr=0,sg=0,sb=0,n=0;
    for (var i=0;i<m.length;i++){
      var c=_rgb(m[i]); if(!c || c.a<0.5) continue;
      sr+=c.r; sg+=c.g; sb+=c.b; n++;
    }
    return n ? {r:sr/n,g:sg/n,b:sb/n,a:1} : null;
  }
  function _fondo(el){
    var p=el, capas=[], prof=0, resuelto=false, foto=false;
    while(p && prof<12){
      var cs=getComputedStyle(p);
      var c=_rgb(cs.backgroundColor);
      if (c && c.a>0){ capas.push(c); if (c.a>=0.999){ resuelto=true; break; } }
      var g=_delGradiente(cs.backgroundImage);
      if (g){ capas.push(g); resuelto=true; break; }        /* degradado = fondo real */
      if (cs.backgroundImage && cs.backgroundImage!=='none') foto=true;  /* url(...) */
      p=p.parentElement; prof++;
    }
    var base={r:255,g:255,b:255,a:1};
    for (var i=capas.length-1;i>=0;i--) base=_sobre(capas[i],base);
    return {color:base, imagen:foto, opaco:resuelto};
  }
  function arreglaContraste(n){
    try{
      var fx=_fondo(n.parentElement||n);
      var cs=getComputedStyle(n), col=_rgb(cs.color);
      if (!col) return;
      var op=parseFloat(cs.opacity); if (!(op>0)) op=1;
      var real=_sobre({r:col.r,g:col.g,b:col.b,a:(col.a===undefined?1:col.a)*op}, fx.color);
      if (!fx.opaco && !fx.imagen) return;                 /* fondo desconocido: NO tocar */
      if (_ratio(real, fx.color) >= 4.5) return;          /* WCAG AA: se lee, no tocar */
      if (fx.imagen && !fx.opaco){
        /* Fondo de imagen y ningún color sólido detrás: no se puede medir de
           verdad. Blanco con sombra se lee sobre foto clara y sobre foto oscura. */
        n.style.setProperty('color','#FFFFFF','important');
        n.style.setProperty('text-shadow','0 1px 3px rgba(0,0,0,.75)','important');
      } else {
        var claro={r:255,g:255,b:255}, oscuro={r:26,g:26,b:26};
        var usar = _ratio(claro,fx.color) >= _ratio(oscuro,fx.color)
                 ? 'rgba(255,255,255,.92)' : 'rgba(26,26,26,.88)';
        n.style.setProperty('color', usar, 'important');
      }
      n.style.setProperty('opacity','1','important');
      n.setAttribute('data-kts-contraste','corregido');
    }catch(e){}
  }
  /* Rescate genérico: cualquier texto de un CTA de KTS que quede por debajo de
     2,2:1 es invisible, no "poco contrastado". Umbral deliberadamente bajo para
     tocar SOLO lo que de verdad no se lee. */
  function rescataCTAs(){
    var sel='.kts-btn,.ktslp-btn,.rsp-btn,.kts-final__cta,.kts-pre-note,'
           +'.kts-card a,.ktslp-blog-cta a,.rsp-final,.rsp-final__h,.rsp-final__p';
    var els=document.querySelectorAll(sel);
    for (var i=0;i<els.length;i++){
      var e=els[i];
      if (e.getAttribute('data-kts-contraste')) continue;
      if (!(e.getBoundingClientRect().width>0)) continue;
      try{
        var fx=_fondo(e), cs=getComputedStyle(e), col=_rgb(cs.color);
        if(!col) continue;
        /* REGLA DE ORO: si no se ha podido RESOLVER el fondo, no se toca nada.
           Forzar un color sobre un fondo desconocido es como se rompio este
           boton. Mas vale dejarlo como esta que empeorarlo. */
        if(!fx.opaco) continue;
        var op=parseFloat(cs.opacity); if(!(op>0)) op=1;
        var real=_sobre({r:col.r,g:col.g,b:col.b,a:(col.a===undefined?1:col.a)*op}, fx.color);
        /* Umbral 4,5:1 = WCAG AA para texto normal. El 2,2 de la primera version
           dejaba pasar botones dificiles de leer que no llegaban a invisibles. */
        if (_ratio(real, fx.color) >= 4.5) continue;
        var claro={r:255,g:255,b:255}, oscuro={r:26,g:26,b:26};
        var usar=_ratio(claro,fx.color)>=_ratio(oscuro,fx.color)?'#FFFFFF':'#1A1A1A';
        e.style.setProperty('color', usar,'important');
        e.style.setProperty('opacity','1','important');
        /* Un boton outline sobre fondo oscuro tambien necesita el borde claro */
        if (/outline|ghost/.test(e.className||'') && usar==='#FFFFFF')
          e.style.setProperty('border-color','rgba(255,255,255,.7)','important');
        e.setAttribute('data-kts-contraste','rescatado');
      }catch(err){}
    }
  }
  function marcar(){
    var loc=idioma();
    var enlaces=document.querySelectorAll('a[href*="/products/"]');
    for (var i=0;i<enlaces.length;i++){
      var a=enlaces[i];
      if (a.dataset.ktsPre) continue;
      var m=(a.getAttribute('href')||'').match(/\/products\/([a-z0-9\-]+)/i);
      if (!m) continue;
      var info=MAPA[m[1]];
      if (!info) continue;
      /* Carrito: la miniatura y el título enlazan al mismo producto; la nota va solo una vez (05-oct-2026) */
      if (a.closest('.cart-item__media')) continue;
      if (!esComercial(a)) continue;
      var b=bloque(a);
      if (b && YA.test(b.textContent||'')) { a.dataset.ktsPre='ya'; continue; }
      /* Nada de detectar el fondo: la banda oscura lo es por imagen/gradiente y
         getComputedStyle no la ve, así que la detección de luminancia fallaba y el texto
         salía marrón sobre negro. `color:inherit` hereda el color que el diseñador YA hizo
         legible en ese bloque — blanco sobre oscuro, oscuro sobre claro — y no falla nunca.
         (25-ago-2026, tras dos intentos fallidos de adivinar el fondo.) */
      var n=document.createElement('span');
      n.className='kts-pre-note';
      n.setAttribute('data-kts-for', m[1]);   /* deja rastro: se puede auditar sin adivinar */
      n.textContent=info[loc]||info.en;
      n.setAttribute('style','display:block;width:100%;margin-top:8px;font-size:12.5px;'
        +'line-height:1.35;font-weight:600;letter-spacing:.01em;text-align:inherit;'
        +'color:inherit;opacity:.82');
      /* Si el enlace vive en una fila de botones (flex/grid), la nota va DEBAJO de la fila:
         insertarla junto al enlace la mete ENTRE los botones y parte el CTA en dos. */
      var fila=a.parentElement, esFila=false;
      if (fila){
        var d=getComputedStyle(fila).display;
        esFila = (d==='flex'||d==='inline-flex'||d==='grid') && fila.children.length>1;
      }
      if (esFila && fila.parentNode) fila.parentNode.insertBefore(n, fila.nextSibling);
      else (a.parentNode||a).insertBefore(n, a.nextSibling);
      arreglaContraste(n);   /* medir DESPUÉS de insertar: antes no hay estilos resueltos */
      a.dataset.ktsPre='1';
    }
    rescataCTAs();
  }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',marcar);
  else marcar();
  // el contenido de blog se inyecta tarde en algunos templates
  setTimeout(marcar,900);
  /* Una pasada final tarde: fuentes y CSS diferido pueden cambiar colores
     después del primer render, y una nota legible a los 900 ms puede dejar de
     serlo a los 2,5 s. Re-medir es barato; que no se lea, no. */
  setTimeout(function(){
    var n=document.querySelectorAll('.kts-pre-note');
    for (var i=0;i<n.length;i++){ n[i].removeAttribute('data-kts-contraste'); arreglaContraste(n[i]); }
    rescataCTAs();
  },2500);
})();

/* ─────────────────────────────────────────────────────────────────────────
   CONMUTADOR DE ACABADO (kts-finish-switch-fix-bug087)

   Desde el 27-ago-2026 el nogal y el natural tienen fechas DISTINTAS, así que
   el bloque que se muestra ya no es cosmético: enseñar el equivocado es
   prometerle a un comprador de nogal que su mueble llega un mes antes.

   El snippet kts-preorder-finish-note lleva su propio <script> con la misma
   lógica, y funciona al CARGAR la página pero no reacciona al cambiar de
   variante: comprobado en navegador el 27-ago sobre vinyl-modular-x4, con
   Natural seleccionado y el bloque de noviembre a la vista. Nadie lo había
   notado porque hasta hoy los dos bloques decían la misma fecha.

   Esto no sustituye a aquel script: lo respalda desde un asset que sí se carga
   siempre y que se re-evalúa ante cualquier cambio del DOM, así que da igual si
   Shopify re-renderiza la sección del producto (los <script> insertados por
   innerHTML no se ejecutan). Es idempotente: si el otro ya dejó el estado bien,
   esto escribe el mismo valor.                                            */
(function(){
  var NOG=/walnut|walnuss|nussbaum|nogal|noyer|noce/i;
  /* Se decide por el VALOR de la opción, nunca por el nombre del campo.
     El campo no se llama "Wood" sino "Color-1", y además va traducido
     ("Farbe-1" en DE, "Couleur-1" en FR), así que ninguna lista de nombres
     aguanta los 5 idiomas. Peor: la ficha tiene un segundo campo "Lid Color-2",
     y una búsqueda por nombre podía quedarse con el color de la TAPA y decidir
     la fecha de entrega a partir de él.
     Los valores, en cambio, son inequívocos: Walnut · Walnuss · Noyer · Noce ·
     Nogal frente a Natural. Ningún color de tapa (Yellow, Green, Orange, Blue,
     Tea Gray) colisiona. Comprobado en los 5 idiomas el 27-ago-2026. */
  function esNogal(){
    var els=[].slice.call(document.querySelectorAll(
      'product-info input:checked, product-info select, variant-selects input:checked, variant-selects select'));
    return els.some(function(e){ return NOG.test(e.value||''); });
  }
  var ultimo=null;
  function aplica(){
    var bl=document.querySelectorAll('div[data-finish="walnut"], div[data-finish="natural"]');
    if (!bl.length) return;
    var w=esNogal();
    if (w===ultimo) return;        // sin cambio: no tocamos el DOM
    ultimo=w;
    for (var i=0;i<bl.length;i++){
      var f=bl[i].getAttribute('data-finish');
      bl[i].style.display=((f==='walnut')===w)?'':'none';
    }
  }
  function fuerza(){ ultimo=null; aplica(); }
  document.addEventListener('change',fuerza,true);
  document.addEventListener('click',function(){ setTimeout(fuerza,120); },true);
  /* Solo childList: observar atributos haría que nuestro propio style.display
     volviera a disparar el observador. */
  if (window.MutationObserver){
    var pend=null;
    new MutationObserver(function(){
      if (pend) return;
      pend=setTimeout(function(){ pend=null; fuerza(); },80);
    }).observe(document.documentElement,{childList:true,subtree:true});
  }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',fuerza);
  else fuerza();
  setTimeout(fuerza,500); setTimeout(fuerza,1500);
})();
